<script>
import { ChunkUploadPath } from "@/path.js";
import axios from "axios";

export default {
    watch: {
        chunks(n) {
            if (n.length > 0) {
                this.upload();
            }
        }
    },

    data() {
        return {
            file: null,
            chunks: [],
            totalUploaded: 0, // Cumulative size of all uploaded chunks
            uploadId: null, // Unique identifier for the current upload
            base_node_url: process.env.VUE_APP_API_BACKEND_URL,
        };
    },

    computed: {
        progress() {
            return Math.floor((this.totalUploaded * 100) / this.file?.size);
        },
        formData() {
            let formData = new FormData();

            formData.set("upload_id", this.uploadId); // Include the unique upload ID
            formData.set("is_last", this.chunks.length === 1); // Mark if it's the last chunk
            formData.set("file", this.chunks[0], `${this.file?.name}.part`);

            return formData;
        },
        config() {
            return {
                method: "POST",
                data: this.formData,
                url: this.base_node_url + ChunkUploadPath.CHUNK_UPLOAD,
                headers: {
                    "Content-Type": "application/octet-stream"
                },
                onUploadProgress: event => {
                    // Update only the current chunk's progress
                    const chunkUploaded = event.loaded;
                    this.totalUploaded += chunkUploaded - this.uploaded;
                    this.uploaded = chunkUploaded;
                }
            };
        }
    },

    methods: {
        select(event) {
            this.file = event.target.files.item(0);
            this.createChunks();

            // Generate a unique upload ID when starting a new upload
            this.uploadId = Date.now(); // Example unique ID based on timestamp
        },
        upload() {
            // Reset `uploaded` for the current chunk
            this.uploaded = 0;
            axios(this.config)
                .then(response => {
                    console.log(response);
                    if (this.chunks.length === 1) {
                        // Emit the final response to the parent
                        this.$emit("uploadcomplete", response.data.file_name);
                    }
                    this.chunks.shift();
                })
                .catch(error => {
                    console.error(error);
                });
        },
        createChunks() {
            let size = 500 * 1024; // 500 KB
            let chunks = Math.ceil(this.file.size / size);

            for (let i = 0; i < chunks; i++) {
                this.chunks.push(
                    this.file.slice(
                        i * size,
                        Math.min(i * size + size, this.file.size),
                        this.file.type
                    )
                );
            }
        }
    }
};
</script>

<template>
    <div>
        <input type="file" @change="select">
        <progress :value="progress" max="100"></progress>
    </div>
</template>
